{
  "oneOf": [
    {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "boolean"
          ]
        },
        "description": {
          "type": "string"
        }
      },
      "required": [
        "type",
        "description"
      ],
      "additionalProperties": false
    },
    {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "string"
          ]
        },
        "enum": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "description": {
          "type": "string"
        }
      },
      "required": [
        "type",
        "enum",
        "description"
      ],
      "additionalProperties": false
    }
  ],
  "$id": "https://schemas.gitbook.com/SiteAdaptiveDeterministicJSONSchemaPrimitives.json"
}